import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ToastrService } from 'ngx-toastr';
import { ElectronService } from '../../services/electron.service';
import { ApisService } from '../../services/apis.service';

import { ToStonesPipe } from '../../pipes/to-stones.pipe';
import { ToLbsPipe } from '../../pipes/to-lbs.pipe';

@Component({
  selector: 'app-jockey-weight-in',
  templateUrl: './jockey-weight-in.component.html',
  styleUrls: ['./jockey-weight-in.component.scss']
})

export class JockeyWeightInComponent implements OnInit {

  @ViewChild('weightInStones') weightInStonesElement: ElementRef;
  @ViewChild('weightInLbs') weightInLbsElement: ElementRef;
  @Input() jockey;
  meta: {
    saving: boolean,
    enableSave: boolean
  };
  manualEditing = false;
  disableReadScale = false;
  electronMode: boolean = this.electron.isElectron();
  userId: number;
  jockeyWeights: {
    weightInStones: number,
    weightInLbs: number,
    weightRecorded: number,
    ruleBreach: boolean,
    raw: string
  };

  constructor(
    public activeModal: NgbActiveModal,
    private electron: ElectronService,
    private apiService: ApisService,
    private notification: ToastrService,
    private toLbs: ToLbsPipe,
    private toStones: ToStonesPipe
  ) { }

  ngOnInit() {
    // console.log('[ DEBUG ] Data received:', this.jockey);
    this.meta = {
      saving: false,
      enableSave: false
    };
    this.jockeyWeights = {
      weightInStones: null,
      weightInLbs: null,
      weightRecorded: null,
      ruleBreach: null,
      raw: ''
    };

    this.apiService.observableLoggedIn.subscribe(data => {
      this.userId = data.user_id;
    });

    if (!this.electronMode) {
      this.enableManualEdit();
    }
  }

  enableManualEdit(): void {
    this.manualEditing = !this.manualEditing;
    if (this.manualEditing) {
      this.meta.enableSave = false;
      this.disableReadScale = true;
      this.weightInStonesElement.nativeElement.focus();
    } else {
      this.disableReadScale = false;
      this.checkWeight();
      this.checkRuleBreach();
    }
  }

  // Modded for COVID
  fillExpectedWeight() {
    if (!this.jockeyWeights.weightInStones && !this.jockeyWeights.weightInLbs && this.manualEditing) {
      this.jockeyWeights.raw = 'manual';
      this.jockeyWeights.weightInStones = Math.floor((Number(this.jockey.weights['O'].weightDisplayed)) / 14);
      this.jockeyWeights.weightInLbs = (Number(this.jockey.weights['O'].weightDisplayed)) % 14;
    }
  }

  valueChanged(value, attribute) {
    if (this.manualEditing) {
      if (this.jockeyWeights[attribute] !== Number(value)) {
        this.jockeyWeights.raw = 'manual';
      }
    }
  }

  checkWeight(): void {
    this.meta.enableSave = (this.jockeyWeights.weightInStones !== null || this.jockeyWeights.weightInLbs !== null);
  }

  // Modded for COVID
  checkRuleBreach(asBoolean = true) {
    const highestDiff = 2;
    const lowestDiff = -1;
    const weightIn = this.jockeyWeights.weightRecorded = this.weightRoundDown(
      (Number(this.jockeyWeights.weightInStones) * 14) + Number(this.jockeyWeights.weightInLbs)
    );
    const weightOut = Number(this.jockey.weights['O'].weightRecorded);
    console.log('OUT', typeof weightOut, weightOut);
    console.log('IN', typeof weightIn, weightIn);
    if (weightIn - weightOut >= highestDiff || weightIn - weightOut < lowestDiff) {
      // this.jockeyWeights.ruleBreach = Boolean(weightIn - weightOut);
      this.notification.info(`The Jockey will be in rule breach for ${(weightIn - weightOut).toFixed(1)} lbs.`, 'Weigh-Out');
      return asBoolean ? Boolean(weightIn - weightOut) : weightIn - weightOut;
    } else {
      // this.jockeyWeights.ruleBreach = false;
      return asBoolean ? false : 0;
    }
  }

  weightRoundDown(weightLbs) {
    if (Math.abs(weightLbs) % 1 > 0.5) {
      return Math.round(Math.abs(weightLbs)) * Math.sign(weightLbs);
    } else {
      return Math.floor(Math.abs(weightLbs)) * Math.sign(weightLbs);
    }
  }

  readScale(): void {
    this.manualEditing = false;
    this.disableReadScale = true;

    this.electron.errorSerialPort().catch(err => {
      this.electron.closeSerialPort();
    });

    this.electron.getSerialPorts()
    .then((ports: [any]) => {
      if (ports.length) {
        const portConfig =  { baudRate: 9600, dataBits: 8, stopBits: 1, parity: 'none', rtscts: true };
        const portName = ports[String(ports.length - 1)];

        this.electron.readSerialPort(portName, portConfig)
        .then((data: string) => {
          // console.log(`[ DEBUG ] DATA FROM ${portName}:`, data.substring(1, data.length-1));
          this.electron.closeSerialPort();
          this.disableReadScale = false;
          this.jockeyWeights = {
            weightInStones: Number(data.substring(1, data.length - 1).trim().replace('  ', ' ').split(' ')[0]),
            weightInLbs: Number(data.substring(1, data.length - 1).trim().replace('  ', ' ').split(' ')[1]),
            weightRecorded: null,
            ruleBreach: null,
            raw: data
          };
          this.checkWeight();
          this.checkRuleBreach();
        })
        .catch(err => {
          console.error(`[ DEBUG ] Error Reading from ${portName}:`, err);
          this.notification.info(`Error reading from ${portName}. Maybe the scale was not settled. Try again.`, 'Scale Reading');
          this.electron.closeSerialPort();
          this.jockeyWeights.weightInStones = null;
          this.jockeyWeights.weightInLbs = null;
          this.checkWeight();
          this.disableReadScale = false;
        });

      } else {
        console.error('[ DEBUG ]  No Serial Ports Detected');
        this.notification.error(`No serial port detected.`, 'Scale Reading');
        this.jockeyWeights.weightInStones = null;
        this.jockeyWeights.weightInLbs = null;
        this.checkWeight();
        this.disableReadScale = false;
      }
    })
    .catch(err => {
      console.error('[ DEBUG ] Cannot get the list of serial ports', err);
      this.notification.error(`Could't access serial ports list.`, 'Scale Reading');
    });
  }

  // Modded for COVID
  confirm() {
    this.meta.saving = true;
    const weightDisplayedLbs = (Number(this.jockeyWeights.weightInStones) * 14) + Number(this.jockeyWeights.weightInLbs);
    const payload = {
      animalId: this.jockey.animalId,
      jockeyId: this.jockey.jockeyId,
      yearOfRace: this.jockey.yearOfRace,
      raceId: this.jockey.raceId,
      divisionSequence: this.jockey.divisionSequence,
      weightDisplayed: weightDisplayedLbs,
      weightRecorded: this.jockeyWeights.weightRecorded,
      raw: this.jockeyWeights.raw,
      weighed: 'I',
      ruleBreach: this.jockeyWeights.ruleBreach,
      type: this.jockeyWeights.raw === 'manual' ? 'M' : 'S',
      updatedBy: this.userId
    };
    console.log(`[ DEBUG ] Sending payload`, payload);
    this.apiService.updateJockeyWeights(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload)
      .subscribe(
        res => {
          // console.log('[ DEBUG ] Jockey Data Saved:', res);
          this.activeModal.close(Object.assign({}, res, { triggerRuleBreach: this.checkRuleBreach(true) }));
          this.notification.success(`${this.jockey.jockeyName} weight-in has been saved.`, 'Weigh-In');
        },
        err => {
          console.error('[ DEBUG ] Error updating Jockey', err);
          this.notification.error(`Could't save the weight-in. Check your connection and Try again.`, 'Weigh-In');
          this.meta.saving = false;
        }
      );
  }

  cancel(action) {
    if (this.electronMode) {
      this.electron.closeSerialPort();
    }
    this.activeModal.dismiss(action);
  }
}
